import React from "react";
import {IS_CORDOVA} from "../envs/_current/config";

const Ahref = ({
                   href,
                   children,
                   onClick,
                   ...props
               }) => {

    const handleClick = (e) => {
        const _href = href || '#'

        if (IS_CORDOVA) {
            // External protocols → open in OS system browser, never hijack webview
            if (/^(https?:|mailto:|tel:|intent:|geo:|sms:)/i.test(_href)) {
                e.preventDefault()
                e.stopPropagation()
                if (window?.cordova?.InAppBrowser) {
                    window.cordova.InAppBrowser.open(_href, "_system", "location=yes")
                } else {
                    window.open(_href, "_blank", "noopener,noreferrer")
                }
                if (typeof onClick === 'function') onClick(e)
                return
            }
            // Internal paths → let React Router / app handle
            if (
                _href.startsWith("/") ||
                _href.startsWith(".") ||
                _href.startsWith("#") ||
                _href.startsWith("file:")
            ) {
                if (typeof onClick === 'function') onClick(e)
                return
            }
            // Unknown scheme → block to be safe
            e.preventDefault()
            return
        }

        // Non-Cordova: browser handles href/target normally, just fire callback
        if (typeof onClick === 'function') onClick(e)
    }

    return (
        <a
            href={href || '#'}
            onClick={handleClick}
            {...props}
        >
            {children}
        </a>
    )
}

export default Ahref
